import { useState } from "react"

const ImagePreview = (props: any) => {
  const [scaleTo, setScaleTo] = useState(1)

  const onScale = (zoomIn: boolean) => (e: any) => {
    if (zoomIn && scaleTo < 3) return setScaleTo(scaleTo + 0.5)
    if (!zoomIn && scaleTo > 1) setScaleTo(scaleTo - 0.5)
  }

  return (
    <div
      className="flex flex-col fixed inset-0 z-[100] p-6 items-center justify-center bg-[#3339] overflow-scroll"
      onMouseDown={props.onClose}
    >
      <div
        onMouseDown={props.onClose}
        className="flex right-4 top-4 shadow-none justify-center items-center rounded-full overflow-clip cursor-pointer bg-white fixed max-w-[38px] w-[38px] max-h-[38px] h-[38px]"
      >
        <i
          className="dripicons-cross text-[28px] mb-[3px]"
          onClick={props.close}
        />
      </div>
      <div
        className="max-h-[80vh] max-w-[80vw]"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <img
          data-dz-thumbnail=""
          style={{ transform: `scale(${scaleTo})` }}
          className={`rounded bg-gray-200 min-w-[50vw] w-full h-auto object-contain`}
          alt={props.url?.split?.("/")?.at(-1)}
          src={props.url}
        />
      </div>
      {/* <div className="fixed bottom-4 right-4 flex gap-2">
        <div onClick={onScale(false)} className="p-3 rounded-full bg-white ">
          +
        </div>
        <div onClick={onScale(true)} className="p-3 rounded-full bg-white ">
          +
        </div>
      </div> */}
    </div>
  )
}
export default ImagePreview
